var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('header-affiliate'),_c('list-affiliate'),_c('form-history'),_c('form-affiliate-pause')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }